import React from 'react';
import './map-button.css';
const ThemeSwitcher = (props) => (React.createElement("form", { className: `map-button ${props.currentTheme}`, onSubmit: props.onSubmit },
    React.createElement("button", { className: "btn btn-outline btn-outline-dark", type: "submit" }, (props.currentTheme === 'light') ? 'Switch to dark mode' : 'Switch to light mode')));
export default ThemeSwitcher;
